import { BASE_BE_URL } from "../AppEnv";
import { SignedInDoctor, UnloggedDoctor } from "../auth/interfaces";
import {
  ALMSG_INTERNAL_ERR,
  ALMSG_UNAUTHORIZED_OP,
  BASE_DOC_SUBURL,
  BASE_MEDSTUDIO_SUBURL,
} from "../env";
import { Doctor } from "./interfaces";

export async function updateDoctorData(
  editedDoctor: SignedInDoctor
): Promise<SignedInDoctor> {
  try {
    const myId = editedDoctor.id;
    if (!Number.isNaN(myId) && myId > 0) {
      return await (
        await fetch(BASE_BE_URL + BASE_DOC_SUBURL + myId, {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + editedDoctor.token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(editedDoctor),
        })
      ).json();
    } else return UnloggedDoctor;
  } catch (error) {
    //console.log("Error: " + error);
    return UnloggedDoctor;
  }
}

export async function getAllDoctors(
  signedInDoctor: SignedInDoctor,
  basic?: boolean
): Promise<Doctor[]> {
  try {
    /*console.log(
      "Get all Doctors for medical studio ",
      JSON.stringify(signedInDoctor.medicalStudioId)
    );*/
    const response = await (
      await fetch(BASE_BE_URL + BASE_DOC_SUBURL + (basic ? "?basic=1" : ""), {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
    ).json();

    return response;
  } catch (error) {
    return [];
  }
}

export async function editDoctor(
  signedInDoctor: SignedInDoctor,
  editedDoctor: Doctor
): Promise<string> {
  try {
    console.log("Edit Doctor with data ", JSON.stringify(editedDoctor));
    const response = await fetch(
      BASE_BE_URL + BASE_DOC_SUBURL + editedDoctor.id,
      {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editedDoctor),
      }
    );

    if (response.ok) return JSON.stringify(await response.json());

    if (response.status == 400)
      return formatMsgError((await response.json()).message);
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

export async function addDoctor(
  signedInDoctor: SignedInDoctor,
  editedDoctor: Doctor
): Promise<string> {
  try {
    console.log("Dati inviati al server:", JSON.stringify(editedDoctor));
    const response = await fetch(BASE_BE_URL + BASE_DOC_SUBURL, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + signedInDoctor.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(editedDoctor),
    });

    if (response.ok) return JSON.stringify(await response.json());

    if (response.status === 400) {
      return formatMsgError((await response.json()).message);
    } else if (response.status === 401) {
      return ALMSG_UNAUTHORIZED_OP;
    } else {
      return ALMSG_INTERNAL_ERR;
    }
  } catch (error: any) {
    console.error("Errore in addDoctor:", error);
    return ALMSG_INTERNAL_ERR;
  }
}

export async function getDoctorData(
  signedInDoctor: SignedInDoctor,
  doctorId: number
): Promise<SignedInDoctor> {
  try {
    const myId = signedInDoctor.id;
    if (!Number.isNaN(myId) && myId > 0) {
      return await (
        await fetch(BASE_BE_URL + BASE_DOC_SUBURL + doctorId, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + signedInDoctor.token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
      ).json();
    } else return UnloggedDoctor;
  } catch (error) {
    //console.log("Error: " + error);
    return UnloggedDoctor;
  }
}
function formatMsgError(message: any): string | PromiseLike<string> {
  throw new Error("Function not implemented.");
}
